import getRetailMFELocationState from '../../../../experiments/mybag-3716-store_selector_mfe/utils/get-retail-mfe-location-state';

/**
 * @function locationStateReconciler reconciles the location state from the Retail MFEs with the persisted values from our store
 * @param {Object} inboundState - persisted values from our store
 * @param {string} inboundState.postalCode
 * @param {string} inboundState.locationId
 * @returns {Object} reconciledState - the value that is rehydrated into our redux store. it is the Retail MFE
 * state if it exists, if not, it's our persisted store values
 * @returns {string} reconciledState.postalCode
 * @returns {string} reconciledState.locationId
 
 */
/*
 * MYBAG-4016: We're only supporting our own persisted state to support MYBAG-3716's control variant. Once it is cleaned up and the
 * Store Selector MFE variant is promoted globally, we can just rely on reading from local storage directly and can
 * remove this from our redux store
 */
const locationStateReconciler = inboundState => {
  const { postalCode, locationId } = getRetailMFELocationState();

  // if we see values present in the MFE we default to those
  // assumes postal code and location id default to empty string to maintain type consistency
  if (postalCode || locationId) {
    return { postalCode, locationId };
  }
  // if no values from the MFE's location state, then use our persisted values
  return inboundState;
};

export default locationStateReconciler;
